// Central content for Spartan Packaging landing page
export const COMPANY = {
  name: "Spartan Packaging",
  legal: "Spartan Packaging (M) Sdn Bhd",
  legal2: "Spartan Automation Sdn Bhd",
  tagline: "Your Packing Solution Provider",
  phone: "+603-7847 1800",
  fax: "+603-7846 2072",
  email: "sales@spartanpack.com",
  address:
    "No. 16-G & 16-1, Jalan Suria R U5/R, Bandar Pinggiran Subang, Seksyen U5, 40150, Shah Alam, Selangor, Malaysia",
  hours: "Mon – Fri: 9AM – 6PM",
  since: "2026",
};

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Solutions", href: "#solutions" },
  { label: "Events", href: "#events" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    no: "01",
    title: "Primary Packaging",
    desc: "A complete range of primary packaging machines sourced from leading manufacturers worldwide. Talk to us and we advise and guide your choice.",
  },
  {
    no: "02",
    title: "Shrink Wrapping",
    desc: "Case packing and shrink wrapping machines that deliver a cost-effective solution and full protection for your product with a neat finish.",
  },
  {
    no: "03",
    title: "Pallet Wrapper & Palletising",
    desc: "Customised palletising solutions that perfectly match the scale of your production and boost throughput efficiency.",
  },
  {
    no: "04",
    title: "Inspection Solution",
    desc: "Reliable inspection safeguards your product's safety, rejecting any foreign contaminants before they leave your line.",
  },
  {
    no: "05",
    title: "Secondary Packaging",
    desc: "We integrate various packing machines to deliver a turnkey, end-to-end secondary packing process built around you.",
  },
  {
    no: "06",
    title: "Pharmaceutical",
    desc: "Advanced pharmaceutical machinery — homogenizers, heated melters, tube fillers — engineered for your requirements.",
  },
];

export const SOLUTIONS = [
  {
    title: "Shrink Wrapping",
    machines: [
      "Packaging Material",
      "Chamber Type Shrink Wrapping",
      "Semi-Automatic L-Bar Sealer",
      "Automatic L-Bar Sealer & Shrink Tunnel",
      "High Speed Shrink Wrapping",
      "Sleeve Wrapping Machines",
      "Flow Wrapping Machine",
      "Vacuum Pack Machine",
      "Strapping Machine",
    ],
    image:
      "https://images.pexels.com/photos/5532716/pexels-photo-5532716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Primary Packaging",
    machines: [
      "Vertical Form-Fill Seal (VFFS)",
      "Horizontal Form-Fill Seal (HFFS)",
      "Labelling Machine",
      "Sleeving Machine",
      "Filling Machine",
      "Tube Fillers",
      "Bagging Machine",
    ],
    image:
      "https://images.pexels.com/photos/34207359/pexels-photo-34207359.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Palletizing & Conveying",
    machines: [
      "Pallet Wrapper Machine",
      "Pallet Inverter",
      "Pallet Stacker / Dispenser — Palomat",
      "Robotic & Conventional Palletizing",
      "Conveyor System",
    ],
    image:
      "https://images.unsplash.com/photo-1563968743333-044cef800494?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxyb2JvdGljJTIwcGFsbGV0aXppbmclMjBmYWN0b3J5fGVufDB8fHx8MTc4NDgwMjQyMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Inspection & Secondary",
    machines: [
      "Metal Detector",
      "Check Weighers",
      "Case Packer",
      "Case Erector",
      "Case Sealer",
      "Cartoning Machine",
      "Overwrapping Machines",
    ],
    image:
      "https://images.unsplash.com/photo-1701328778019-e95dedbf5346?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwY29udmV5b3IlMjBiZWx0fGVufDB8fHx8MTc4NDgwMjQyMHww&ixlib=rb-4.1.0&q=85",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Engineered Precision",
    body: "Every line we design is tuned to the millimetre. We source machinery from the world's leading manufacturers and integrate it into a process that runs like clockwork on your factory floor.",
  },
  {
    no: "02",
    title: "Turnkey Automation",
    body: "From primary fill to final palletizing, we deliver a complete, integrated solution — one accountable partner from the first sealed pack to the shipped pallet.",
  },
  {
    no: "03",
    title: "Built To Endure",
    body: "Heavy-industrial strength is our baseline. Robust frames, reliable inspection and relentless uptime keep your production moving, shift after shift.",
  },
];

export const EVENTS = [
  {
    year: "2018",
    title: "29th Malaysia Int'l Food Processing & Packaging Exhibition (M'SIA-PACK)",
    date: "19 – 22 July 2018",
    location: "Kuala Lumpur, Malaysia",
  },
  {
    year: "2017",
    title: "28th Malaysia Int'l Food Processing & Packaging Exhibition (M'SIA-PACK)",
    date: "27 – 30 July 2017",
    location: "Kuala Lumpur, Malaysia",
  },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/34207359/pexels-photo-34207359.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  factory:
    "https://images.unsplash.com/photo-1717386255767-52643970d483?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwcGFja2FnaW5nJTIwbWFjaGluZXJ5fGVufDB8fHx8MTc4NDgwMjQyMHww&ixlib=rb-4.1.0&q=85",
};
